/**
 * La alerta de cuenta compartida no mueve `status` a propósito: dos teléfonos
 * reportando por la misma sesión no es un GPS manipulado. Preguntar solo por
 * `status !== 'none'` la deja invisible, que es lo que pasaba en esta
 * plataforma mientras intra ya la mostraba.
 */
export function hasGpsIntegritySignal(gpsIntegrity) {
  if (!gpsIntegrity) return false
  if (gpsIntegrity.status && gpsIntegrity.status !== 'none') return true
  return (gpsIntegrity.sharedAccountAlerts || 0) > 0
}

/** Cuenta compartida es un hecho medido, no una sospecha: va en rojo */
export function isSevereGpsIntegrity(gpsIntegrity) {
  if (!gpsIntegrity) return false
  if (gpsIntegrity.status === 'confirmed') return true
  return (gpsIntegrity.sharedAccountAlerts || 0) > 0
}

/** Texto del aviso, que nombra las dos cosas cuando ocurren juntas */
export function getGpsIntegrityLabel(gpsIntegrity) {
  if (!gpsIntegrity) return ''
  const hasManipulation = Boolean(gpsIntegrity.status && gpsIntegrity.status !== 'none')
  const sharedAccount = (gpsIntegrity.sharedAccountAlerts || 0) > 0
  const manipulationLabel = gpsIntegrity.statusLabel || 'Señales de GPS manipulado'

  if (hasManipulation && sharedAccount) return `${manipulationLabel} · Cuenta compartida`
  if (hasManipulation) return manipulationLabel
  return 'Cuenta compartida'
}
